"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TbErrorDialog = void 0;
var react_1 = __importDefault(require("react"));
var TbDialog_1 = require("./TbDialog");
var TbErrorDialog = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Something went wrong' : _b, _c = _a.message, message = _c === void 0 ? 'Unknown error' : _c, open = _a.open, handleClose = _a.handleClose;
    return (react_1.default.createElement(TbDialog_1.TbDialog, { title: title, message: message, color: 'rgb(218, 71, 37)', open: open, closeButton: 'OK', handleClose: handleClose }));
};
exports.TbErrorDialog = TbErrorDialog;
//# sourceMappingURL=TbErrorDialog.js.map